import { h } from '@stencil/core';

const CDN_DOMAIN = 'https://kia-afonso.b-cdn.net';
const ORIGINAL_DOMAIN = 'kia.com';

interface CDNImageProps {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  quality?: number;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  className?: string;
}

const KIAImage = ({ src, alt, width = '100%', height = 0, quality = 80, sizes, loading = 'lazy', className }: CDNImageProps) => {
  const isKiaUrl = (url: string) => url?.includes(ORIGINAL_DOMAIN);

  const generateSrcSet = (path: string) => {
    const resolutions = [640, 1080, 1920, 2560];
    return resolutions.map(res => `${CDN_DOMAIN}/${path}?width=${res}&q=${quality} ${res}w`).join(', ');
  };

  let finalSrc = src;
  let srcSet: string;

  if (isKiaUrl(src)) {
    const urlParts = new URL(src);
    const path = urlParts.pathname + urlParts.search + urlParts.hash;
    finalSrc = `${CDN_DOMAIN}${path}?w=${width}&quality=${quality}`;
    srcSet = generateSrcSet(path);
  }

  return <img src={finalSrc} alt={alt} width={width} height={height} sizes={sizes} srcSet={srcSet} loading={loading} class={className} />;
};

export default KIAImage;
